var map = {
	"./Ablaze.json": 24089,
	"./Accelerated growth.json": 52682,
	"./Anger.json": 91199,
	"./Armor.json": 40457,
	"./Arouse.json": 86956,
	"./Assassin.json": 2059,
	"./Assimilation.json": 33137,
	"./Aurora veil.json": 21362,
	"./Aurora.json": 75727,
	"./Automatic.json": 30679,
	"./Blitz.json": 11406,
	"./Boosting.json": 21093,
	"./Bounce show.json": 70049,
	"./Bounce.json": 3930,
	"./Braid of fire.json": 2793,
	"./Breathing.json": 85761,
	"./Buildup.json": 29717,
	"./Bull drive.json": 49374,
	"./Bunker.json": 17872,
	"./Card milking.json": 7975,
	"./Chill.json": 23836,
	"./Clean show.json": 46816,
	"./Combo.json": 49982,
	"./Confusion.json": 70302,
	"./Contest finale.json": 62769,
	"./Contest gold point.json": 41439,
	"./Contest point.json": 23663,
	"./Counterattack.json": 25459,
	"./Cowgirl contest.json": 74371,
	"./Crimson poison.json": 20740,
	"./Crumbling.json": 22141,
	"./Crystal body.json": 87593,
	"./Crystallize.json": 69225,
	"./Curses/Corruption.json": 58558,
	"./Curses/Darkness.json": 6960,
	"./Curses/Slime body.json": 39036,
	"./Dashing.json": 11676,
	"./Dawnbreak.json": 39879,
	"./Defense.json": 72319,
	"./Drifting.json": 31427,
	"./Earthbound.json": 91202,
	"./Echo.json": 14069,
	"./Eleni.json": 19524,
	"./Embers.json": 57828,
	"./Endowed.json": 2597,
	"./Energetic.json": 41256,
	"./Entangled.json": 63052,
	"./Expanding force.json": 379,
	"./Expanding.json": 67085,
	"./Exposed.json": 41356,
	"./Facing back.json": 59102,
	"./Feral growth.json": 75969,
	"./Feral.json": 97391,
	"./Fire slime.json": 53658,
	"./Fire volley.json": 19639,
	"./Fire whirl.json": 57306,
	"./Fireflow.json": 77233,
	"./Fission.json": 58473,
	"./Flash step.json": 82049,
	"./Flash.json": 13408,
	"./Flip.json": 6109,
	"./Flow.json": 10289,
	"./Fluffy.json": 69293,
	"./Focus.json": 16270,
	"./Fragrance.json": 97199,
	"./Frail.json": 92182,
	"./Freeze.json": 12232,
	"./Frustration.json": 830,
	"./Fumes.json": 16067,
	"./Gaining ground.json": 14023,
	"./Galvanize.json": 62188,
	"./Hand clap.json": 61105,
	"./Healbound.json": 31569,
	"./Hidden.json": 29501,
	"./High beat.json": 70555,
	"./Holding out.json": 12352,
	"./Inaccessible.json": 19657,
	"./Influx.json": 88070,
	"./Inquisitive.json": 5403,
	"./Intensity.json": 20222,
	"./Invincibility.json": 89103,
	"./Iron surge.json": 94596,
	"./Jump squat.json": 94802,
	"./Kindling.json": 47086,
	"./Lena.json": 21917,
	"./Life loop.json": 68586,
	"./Limit break.json": 86475,
	"./Low beat.json": 13093,
	"./Magic fingers.json": 13274,
	"./Magic mouth.json": 52398,
	"./Mana leaf.json": 54163,
	"./Mana loop.json": 49423,
	"./Mana milking.json": 42780,
	"./Mana stem.json": 1528,
	"./Mana wisp.json": 7795,
	"./Masochism.json": 74008,
	"./Milk bottle.json": 38926,
	"./Milk show.json": 63441,
	"./Milkscreen.json": 72131,
	"./Mini.json": 1660,
	"./Minion.json": 97702,
	"./Momentum.json": 87166,
	"./Moss.json": 85508,
	"./Mucus.json": 54891,
	"./Nature's gift.json": 52850,
	"./Oozing.json": 88102,
	"./Other/Augment.json": 87257,
	"./Other/Augmentextra.json": 36544,
	"./Other/Burning.json": 4782,
	"./Other/Corrupt.json": 46451,
	"./Other/Discount.json": 93605,
	"./Other/Edge.json": 53568,
	"./Other/Engine.json": 58865,
	"./Other/Ethereal.json": 47358,
	"./Other/Evanescence.json": 34927,
	"./Other/Exhaust.json": 12987,
	"./Other/Exp.json": 58221,
	"./Other/Gold.json": 98583,
	"./Other/HP.json": 52810,
	"./Other/Insight.json": 4342,
	"./Other/Locked.json": 15799,
	"./Other/Recovery.json": 18511,
	"./Other/Runes.json": 35653,
	"./Other/Shards.json": 45582,
	"./Other/Turn back.json": 42523,
	"./Other/Turn forward.json": 6683,
	"./Other/Vanish.json": 91249,
	"./Other/Volatile.json": 65212,
	"./Other/fifth.json": 93134,
	"./Other/fourth.json": 39153,
	"./Other/half.json": 19098,
	"./Other/last turn.json": 78622,
	"./Other/third.json": 43444,
	"./Out of phase.json": 51298,
	"./Overflow.json": 24766,
	"./Overgrowth.json": 33874,
	"./Overload.json": 37626,
	"./Overmind.json": 41559,
	"./Owlsight.json": 95157,
	"./Permanent assassin.json": 32922,
	"./Permanent shield breaker.json": 12550,
	"./Pestilence.json": 34853,
	"./Phantom force.json": 91931,
	"./Phantom wave.json": 8821,
	"./Phantom.json": 86447,
	"./Pheromones.json": 35238,
	"./Photosynthesis.json": 10915,
	"./Pile of bones.json": 26918,
	"./Poison.json": 43507,
	"./Power trip.json": 27355,
	"./Power.json": 19249,
	"./Predation.json": 24904,
	"./Puffy.json": 8563,
	"./Quake.json": 6059,
	"./Radiance.json": 64169,
	"./Rage.json": 86757,
	"./Raising.json": 61999,
	"./Rebirth.json": 92298,
	"./Rebuke.json": 76538,
	"./Reflexes.json": 18403,
	"./Reformation.json": 1288,
	"./Regeneration.json": 17037,
	"./Replicate.json": 52873,
	"./Resonance.json": 34640,
	"./Ring of fire.json": 629,
	"./Rock solid.json": 3,
	"./Rotten leaf.json": 50546,
	"./Rotten.json": 1603,
	"./Rumble.json": 90724,
	"./Scaling.json": 90676,
	"./Shackled.json": 74448,
	"./Shield breaker.json": 33458,
	"./Slime.json": 21629,
	"./Slow.json": 27491,
	"./Sluggish.json": 77931,
	"./Smokescreen.json": 7161,
	"./Song of gales.json": 18607,
	"./Soulbound.json": 26230,
	"./Speed up.json": 22020,
	"./Spikes.json": 8100,
	"./Spiny.json": 74782,
	"./Split.json": 80036,
	"./Spore release.json": 29346,
	"./Squeezed.json": 73388,
	"./Stolen spotlight.json": 12886,
	"./Stone absorb.json": 90553,
	"./Stone skin I.json": 81836,
	"./Stone skin II.json": 89646,
	"./Stone skin III.json": 50883,
	"./Stuck.json": 81416,
	"./Submissive.json": 44725,
	"./Super vulnerable.json": 47626,
	"./Superheavy.json": 16103,
	"./Swirling blaze.json": 88991,
	"./Tension down.json": 60274,
	"./Tension lock.json": 55091,
	"./Tension.json": 87076,
	"./Thick blood.json": 14931,
	"./Thorns.json": 62377,
	"./Timewarp.json": 79210,
	"./Totem.json": 76630,
	"./Transcendence.json": 47772,
	"./Treeform.json": 79897,
	"./Turn ended.json": 52823,
	"./Unfazed.json": 84315,
	"./Vacuum stream.json": 31658,
	"./Vacuum wave.json": 46610,
	"./Vulnerable.json": 89949,
	"./Wake up.json": 52502,
	"./Weak.json": 43039,
	"./Webmaking.json": 97784,
	"./Witched.json": 32107,
	"./Woodcutter.json": 23230,
	"./Workaholic.json": 75992,
	"./Yokai setup.json": 46807,
	"./Yokai.json": 9664,
	"./Zen.json": 31931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67990;